import styles from "../../styles/info/AboutAdjuster.module.css";
import adjData from "../../data/aboutAdj.json";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function AboutAdjuster() {
  return (
    <div className={cx("aboutAdjusterWrap")}>
      <div className={cx("detailContainer")}>
        <div className={cx("title")}>
          <h4>{adjData.title}</h4>
          <p className={cx("subTitle")}>{adjData.desc}</p>
        </div>
      </div>

      <div className={cx("detailPurpose", "reveal")}>
        <div className={cx("purposeTextWrap")}>
          <h4 className={cx("detailPurposeTitle")}>{adjData.purpose.title}</h4>
          <p className={cx("detailPurposeDesc")}>{adjData.purpose.desc}</p>
        </div>

        <div className={cx("purposeImgWrap")}>
          <img src={adjData.purpose.img} alt="손해사정 도입 목적" />
        </div>
      </div>

      <div className={cx("detailContext", "reveal")}>
        {adjData.content.map((text, index) => (
          <p key={index} className={cx("detailParagraph")}>
            {text}
          </p>
        ))}
      </div>
    </div>
  );
}
